export class UnplannedPickupOrder {

    public orderId : string = '';

    public description : string = '';

    public jobName : string = '';

    /** The group the order is in, which is how a dealer's pickups or the deliveries to an address are split */
    public groupId : number = 0;

    public rowVersion : string = '';

}
